import stores from 'cd-eft/models/Stores';
import { GraphicsLayer, MapImageLayer } from 'cd-eft/utils/esriTypes';

const setStore = stores.AppStore.surveyEngineeringStore;
const gisModel = stores.AppStore.surveyEngineeringStore.gisModel;

export function resetMap() {
  // console.log('resetMap');
  let removedLayers;
  if (gisModel.map) {
    removedLayers = gisModel.map.removeAll();
    for (const layer of removedLayers) {
      if (layer instanceof GraphicsLayer || setStore.SETMapLayerKeepList.includes(layer.id) || layer instanceof MapImageLayer) {
        gisModel.map.add(layer);
      }
    }
  }
}
